import { Routes } from '@angular/router';

import { ShellComponent } from './layout/shell.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { permissionGuard } from './core/auth/guards/permission.guard';

export const routes: Routes = [
	{
		path: '',
		component: ShellComponent,
		canActivate: [authGuard],
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'pacientes' },
			{
				path: 'compromisos',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:commitments' },
				loadComponent: () => import('./features/patients/patient-plans.page').then((m) => m.PatientPlansPage)
			},
			{
				path: 'movimientos',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:movements' },
				loadComponent: () => import('./features/movements/movements.page').then((m) => m.MovementsPage)
			},
			{
				path: 'frecuencias-notificacion',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:configs' },
				loadComponent: () => import('./features/reminders/payment-reminder-settings.page').then((m) => m.PaymentReminderSettingsPage)
			},
			{
				path: 'pacientes/:id/planes-cuotas',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:patients' },
				loadComponent: () => import('./features/patients/patient-plans.page').then((m) => m.PatientPlansPage)
			},
			{
				path: 'pacientes',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:patients' },
				loadComponent: () => import('./features/patients/patients.page').then((m) => m.Patients)
			},
			{

				path: 'equipo',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:professionals' },
				loadComponent: () => import('./features/users/users.page').then((m) => m.UsersPage)
			},
			{
				path: 'archivos',
				loadComponent: () => import('./features/files/files').then((m) => m.Files)
			},
			{
				path: 'cronograma',
				//canActivate: [authGuard, permissionGuard],
				//data: { requiredPermission: 'module:schedule' },
				loadComponent: () => import('./features/schedule/schedule').then((m) => m.Schedule)
			},
			{
				path: 'reporte-financiero',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'reports:read' },
				loadComponent: () => import('./features/reports/financial-report/financial-report.page').then((m) => m.FinancialReportPage)
			}

		]
	},
	{
		path: 'callback',
		loadComponent: () =>
			import('./core/auth/components/auth-callback/auth-callback.component').then(
				(m) => m.AuthCallbackComponent
			)
	},
	{ path: '**', redirectTo: 'pacientes' }
];
